<template>
    <div class="maxkey-login" v-loading="loading">
        <el-button type="primary" style="width: 100%; font-size: 18px" @click="maxkeyLogin">统一登录</el-button>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import LOGIN_SUCCESS from '../mixins/login-success.js';

export default {
    mixins: [LOGIN_SUCCESS],
    data() {
        return {
            loading: false,
        };
    },
    computed: {},
    watch: {},
    methods: {
        ...mapMutations({
            userinfoUpdata: 'userinfo/userinfoUpdata', //用户信息
        }),

        maxkeyLogin() {
            this.loading = true;

            this.$get(`${this.$store.state.api.baseUrl}/client/maxkeyAuthUrl`, {}, (data) => {
                if (data) {
                    window.location.href = data;
                } else {
                    showMessageBox('获取登录地址失败');
                }

                this.loading = false;
            });
        },
    },

    beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '@css/var.scss';
.wx-login {
    .wxQrcode {
        font-size: 0;
        position: relative;

        img {
            transition: all 0.3s;
        }
    }

    .tips {
        white-space: nowrap;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        z-index: 99;
        color: $primaryColor;
        font-weight: bold !important;
        cursor: pointer;
    }

    .remaining-text {
        height: 28px;
        line-height: 28px;
        opacity: 0.6;
    }
}
</style>
